import { observer } from 'mobx-react-lite'

import { TextArea } from 'components'
import { analyticsContext, useValueContext } from 'contexts'
import { FlexLayout } from 'layouts'
import { EventType } from 'types'

import { CurrentDateError, Duration, TimeInputs } from '../../components'
import { DayActiveIcon, DayInactiveIcon, NightActiveIcon, NightInactiveIcon } from './icons'
import './styles.scss'

interface Props {
  current?: boolean
}

export const Sleep = observer(({ current }: Props) => {
  const { eventStore } = useValueContext()
  const { type, event, setType, setEventField, validFunctions } = eventStore

  const isDurationValid = validFunctions[EventType.SLEEP_DAY]

  const DayIcon = type === EventType.SLEEP_DAY ? DayActiveIcon : DayInactiveIcon
  const NightIcon = type === EventType.SLEEP_NIGHT ? NightActiveIcon : NightInactiveIcon

  return (
    <>
      <div className="page-title event-title">Сон</div>

      <FlexLayout.Content className="scrollable-layout event-scrollable" scrollable>
        <div className="sleep-event">
          <div className="type-icons">
            <DayIcon
              className="change-event-icon"
              onClick={() => {
                setType(EventType.SLEEP_DAY)
                analyticsContext.trackEvent('sleep_type_changed', { value: 'DAY' })
              }}
            />
            <NightIcon
              className="change-event-icon"
              onClick={() => {
                setType(EventType.SLEEP_NIGHT)
                analyticsContext.trackEvent('sleep_type_changed', { value: 'NIGHT' })
              }}
            />
          </div>
          <div className="type-name">{type === EventType.SLEEP_DAY ? 'Дневной' : 'Ночной'}</div>
          <div className="sleep-form">
            <div className="time-grid">
              <TimeInputs
                label="Начало"
                value={event?.startTime}
                onChange={(value: string) => setEventField('startTime', value)}
                selectTimeOnRender={current}
                eventType="START"
              />
              <CurrentDateError />
              {!current && (
                <>
                  <TimeInputs
                    label="Конец"
                    value={event?.endTime}
                    onChange={(value: string) => setEventField('endTime', value)}
                    eventType="END"
                  />
                  <Duration
                    isValid={isDurationValid()}
                    startTime={event?.startTime}
                    endTime={event?.endTime}
                  />
                </>
              )}
            </div>
            <TextArea
              className="event-textarea"
              label="Комментарий"
              value={event?.comment}
              onChange={(value: string) => setEventField('comment', value)}
              scrollToOnFocus
            />
          </div>
        </div>
      </FlexLayout.Content>
    </>
  )
})
